import React from 'react';
import { COLORS } from '../constants';

export const KitJar3D = ({ src, line, size = 56, className = '' }) => (
  <span className={`kit-jar3d ${className}`} style={{ '--c': COLORS[line] || '#8a8a94', width: size, height: size }} aria-hidden>
    {src ? <img src={src} alt="" draggable={false} /> : <span className="kit-jar3d-fallback" />}
  </span>
);

export default KitJar3D;
